function PageNotFound() {

    return (
        <div className="pagewrpaper">

            <div className="peace-mind">
                <div className="container">
                    <div className="row m-0 align-items-start">
                        <div className="col-md-12">
                            <div className="text-center sec-title">
                                <h3 className="text-white">404 - The page you are looking for was not found.</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
  
  export default PageNotFound;